// @ts-expect-error module not typed
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const DocLink = ({
  buttonSize = 'sm',
  use = 'link',
  path = '',
  useZorse = true,
  useZorseLink = false,
  onClick = () => {},
  children = /*#__PURE__*/_jsx(_Fragment, {})
}) => {
  const url = path.includes('https://') ? path : `https://knowledge.hubspot.com/${path}`;
  const buttonUse = useZorseLink ? 'link' : use;
  return /*#__PURE__*/_jsx(KnowledgeBaseButton, Object.assign({
    use: buttonUse,
    "data-test-id": `doc-link-${path}`,
    url: url,
    useZorse: useZorse,
    external: false,
    onClick: onClick
  }, !useZorseLink ? {
    size: buttonSize
  } : {}, {
    children: children
  }));
};
export default DocLink;